import React from 'react';

export function Table({ data = [], title = '' }) {
  const columns = [`Estadística: ${title}`, 'CO (ppm)', 'NO (k)', 'NOx (ppm)'];
  const rows = [
    { label: 'Mínimo', badge: 'bg-blue-50 text-blue-700' },
    { label: 'Máximo', badge: 'bg-rose-50 text-rose-700' },
    { label: 'Promedio', badge: 'bg-purple-50 text-purple-700' },
    { label: 'Desviación estándar', badge: 'bg-amber-50 text-amber-700' },
    { label: 'Varianza', badge: 'bg-slate-100 text-slate-700' },
  ];

  const co = data.map((d) => parseFloat(d.co)).filter((v) => !isNaN(v));
  const no = data.map((d) => parseFloat(d.no)).filter((v) => !isNaN(v));
  const nox = data.map((d) => parseFloat(d.nox)).filter((v) => !isNaN(v));

  const safeCalc = (arr, fn) => (arr.length > 0 ? fn(arr) : 0);

  const calcMin = (arr) => Math.min(...arr);
  const calcMax = (arr) => Math.max(...arr);
  const calcAvg = (arr) => arr.reduce((sum, v) => sum + v, 0) / arr.length;
  const calcStdDev = (arr) => {
    const avg = calcAvg(arr);
    return Math.sqrt(arr.reduce((sum, v) => sum + Math.pow(v - avg, 2), 0) / arr.length);
  };
  const calcVar = (arr) => {
    const avg = calcAvg(arr);
    return arr.reduce((sum, v) => sum + Math.pow(v - avg, 2), 0) / arr.length;
  };

  const stats = [
    [safeCalc(co, calcMin), safeCalc(no, calcMin), safeCalc(nox, calcMin)],
    [safeCalc(co, calcMax), safeCalc(no, calcMax), safeCalc(nox, calcMax)],
    [safeCalc(co, calcAvg), safeCalc(no, calcAvg), safeCalc(nox, calcAvg)],
    [safeCalc(co, calcStdDev), safeCalc(no, calcStdDev), safeCalc(nox, calcStdDev)],
    [safeCalc(co, calcVar), safeCalc(no, calcVar), safeCalc(nox, calcVar)],
  ];

  return (
    <div className="w-full border border-slate-100 rounded-2xl overflow-hidden shadow-card bg-white">
      <div className="overflow-x-auto">
        <table className="w-full text-left border-collapse">
          <thead>
            <tr className="bg-slate-50/80 border-b border-slate-100">
              {columns.map((header, i) => (
                <th
                  key={i}
                  className={`px-5 py-3.5 text-xs font-bold uppercase tracking-wider text-slate-500 ${
                    i > 0 ? 'text-right' : ''
                  }`}
                >
                  {header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100 text-sm">
            {rows.map(({ label, badge }, i) => (
              <tr key={i} className="hover:bg-slate-50/50 transition-colors">
                <td className="px-5 py-3.5 font-bold text-slate-700">
                  <span className={`inline-block px-2.5 py-1 rounded-lg text-xs font-bold ${badge}`}>
                    {label}
                  </span>
                </td>
                {stats[i].map((value, j) => (
                  <td key={j} className="px-5 py-3.5 text-right font-mono text-sm font-semibold text-slate-800">
                    {Number(value).toFixed(2)}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

